<template>
  <div
    :class="[
      'custom_container',
      { 'no-background': noBackgroundColor },
      { 'no-border': borderHidden },
      { 'full-height': fullHeight },
      height,
      overflowY,
    ]"
  >
    <div
      v-if="header"
      id="custom_container_header"
      class="custom_container_header"
    >
      <div class="flex flex-row gap-[6px] items-center text-sm text_color">
        <ThemeImage
          v-if="header.icon"
          :class="`${header.size || 'size-4'}`"
          :icon="header.icon"
          :alt="header.alt"
        />
        <div class="flex flex-col justify-center">
          <div class="flex flex-row items-center gap-1.5">
            <span class="font-medium">{{ header.title }}</span>
            <span v-if="header.tag" class="tag_css">{{ header.tag }}</span>
          </div>
          <span class="text-xs secondary_color" v-if="header.description">{{
            header.description
          }}</span>
        </div>
      </div>

      <slot name="trigger" v-if="$slots.trigger"></slot>
      <a-tooltip
        v-else-if="header.execute && showAddButton"
        :title="header.disabled && header.tooltip ? header.tooltip : ''"
        placement="right"
      >
        <span
          :class="[
            'font-normal',
            header.disabled
              ? 'secondary_color cursor-not-allowed opacity-50'
              : 'secondary_color cursor-pointer',
          ]"
          @click="!header.disabled && header.execute()"
        >
          + Add
        </span>
      </a-tooltip>
      <span v-if="previewLeadsCount !== null" class="text-sm secondary_color">
        {{ previewLeadsCount }} estimates
      </span>
    </div>

    <div :class="['flex flex-col w-full h-full', padding]">
      <slot v-if="!showEmptyScreen"></slot>

      <div class="mt-14 mb-16" v-else>
        <EmptyScreen source="custom_container" :text="header.emptyText" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import EmptyScreen from "@/src/components/EmptyScreen.vue";

const props = defineProps({
  header: { type: Object, required: false, default: null },
  padding: { type: String, default: "p-2" },
  height: { type: String, default: "" },
  fullHeight: { type: Boolean, default: false },
  previewLeadsCount: { type: Number, required: false, default: null },
  showAddButton: { type: Boolean, default: true },
  noBackgroundColor: { type: Boolean, default: false },
  borderHidden: { type: Boolean, default: false },
  showEmptyScreen: { type: Boolean, default: false },
  overflowY: { type: String, default: "" },
});
</script>

<style>
.custom_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid var(--white-opacity-8);
  font-family: "Proxima Nova", sans-serif;
}

.custom_container.no-background {
  background: transparent;
}

.custom_container.no-border {
  border: none;
  border-radius: 0;
}

.custom_container.full-height {
  height: 100%;
}

.custom_container_header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--white-opacity-8);
  padding: 12px;
}
</style>
